import { getAuth, signOut } from "firebase/auth";
import { RyeButton } from "../rye/RyeButton";
import { useRyeModal } from "../rye/RyeModal";
import { CancelSubscriptionModal } from "./CancelSubscriptionModal";
import { SettingRow } from "./SettingRow";

export function CancelSubscriptionSetting({
  disabled = false,
}: {
  disabled?: boolean;
}): JSX.Element {
  const { openModal } = useRyeModal();
  return (
    <SettingRow
      label="Cancel Subscription and Delete Account"
      description="Refund full unused months. Permanently delete your data."
      picker={
        <RyeButton
          text="Cancel subscription and delete account"
          vibe="danger"
          disabled={disabled}
          onClick={() =>
            openModal(
              <CancelSubscriptionModal
                onCompleted={() => {
                  void signOut(getAuth()).catch(() => window.location.reload());
                }}
              />,
            )
          }
        />
      }
    />
  );
}
